import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GLOBAL } from '../global';
import { MensajeNovedad } from '../domain/mensaje-novedad';
import { Adjunto } from '../domain/adjunto';
import { AdjuntoService } from './adjunto.service';
import { GenericResponse } from '../domain/genericResponse';
import * as S3 from 'aws-sdk/clients/s3';
import { Novedad } from '../domain/novedad';

@Injectable({
  providedIn: 'root'
})
export class NovedadService {
  urlNovedad: string;
  adjuntoS3: Adjunto;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  totalNovedadesAdministrador : number;
  totalNovedadesCliente : number;

  constructor(
    public httpClient: HttpClient,
    public adjuntoService: AdjuntoService
  ) {
    this.urlNovedad = GLOBAL.URL_BASE + 'sicaNovedad';
  }


  saveNewSicaNovedad(mensajeNovedad: MensajeNovedad, fileToUpload: File, secretId: string, secretKey: string): any {
    if (fileToUpload != null) {
      var adjunto = new Adjunto(null, fileToUpload.name, null,
        null, null, GLOBAL.BUCKET_NOVEDADES, fileToUpload.type, mensajeNovedad.usuarioCreador, null, null, null, null);
      try {


        //console.log("TC= " + fileToUpload.type)
        //console.log("TA= " + adjunto.usuarioCreador)

        this.adjuntoService.saveAdjuntoToS3(adjunto).subscribe(data => {
          let respuestaGenerica: GenericResponse = data;
          if (respuestaGenerica.codigo === GLOBAL.HTTP_OK) {

            this.adjuntoS3 = respuestaGenerica.lista[0];
            const bucket = new S3(
              {
                accessKeyId: secretId,
                secretAccessKey: secretKey,
                region: GLOBAL.REGION_S3
              }
            );

            const params = {
              Bucket: GLOBAL.NOMBRE_BUCKET,
              Key: this.adjuntoS3.rutaAdjunto,
              ACL: "public-read",
              Body: fileToUpload
            };

            bucket.upload(params, function (err, data) {
              if (err) {
                //console.log('Hay un error al subir el adjunto: ', err);
              }
              //console.log('El adjunto fue cargado con éxito.', data);
              //console.log('mensajeNovedad con adjunto', mensajeNovedad);
            });

          } else {
            throw new Error('¡Ha ocurrido un error al guardar el adjunto! ' + respuestaGenerica.mensaje);
          }

        }, error => {
          throw new Error('¡Ha ocurrido un error al cargar el adjunto, por favor, intente más tarde!');
        });

      } catch (error) {
        //console.log(error);
      }
      //console.log('mensajeNovedad con adjunto', mensajeNovedad);
      return this.httpClient.post(this.urlNovedad + '/saveNewSicaNovedadWithSicaAdjunto/', mensajeNovedad, this.httpOptions);
    }
    //console.log('mensajeNovedad sin adjunto', mensajeNovedad);
    return this.httpClient.post(this.urlNovedad + '/saveNewSicaNovedad/', mensajeNovedad, this.httpOptions);
  }

  sendMailNotificationSicaNovedad(novedad: Novedad): any {
    return this.httpClient.post(this.urlNovedad + '/sendMailNotificationSicaNovedad/', novedad, this.httpOptions);
  }

  findAllNovedadesByTipoAndEstado(tipoNovedad:number,
    estadoNovedad:number,
    pedido:number,
    cedula:string,
    nombre:string,
    celular:string,
    email:string,
    dias:number,
    ):any{
    return this.httpClient.get(this.urlNovedad+'/findAllNovedadesByTipoAndEstado/'+tipoNovedad+'/'+estadoNovedad+'/'+pedido+'/'+cedula+'/'+nombre+'/'+celular+'/'+email+'/'+dias);
  }
 
  getSicaNovedadById(idNovedad: number, leidoPorUsuario: string):any{
    return this.httpClient.get(this.urlNovedad+'/getSicaNovedadById/'+idNovedad+'/'+leidoPorUsuario);
  }

  updateSicaNovedadDTO(novedad: Novedad): any {
    return this.httpClient.put(this.urlNovedad + '/updateSicaNovedadDTO/', novedad, this.httpOptions);
  }

  sendMailResponseNotificationSicaNovedad(novedad: Novedad): any {
    return this.httpClient.post(this.urlNovedad + '/sendMailResponseNotificationSicaNovedad/', novedad, this.httpOptions);
  }

  findAllNovedadesByTercTipoAndEstado(tercero:number, tipoNovedad:number, estadoNovedad:number):any{
    return this.httpClient.get(this.urlNovedad+'/findAllNovedadesByTercTipoAndEstado/'+tercero+'/'+tipoNovedad+'/'+estadoNovedad);
  }

  getCountNovedadesByTerc(tercero:number){
    return this.countNovedadesByTerc(tercero).subscribe((data : GenericResponse) => {
      if (data.codigo === GLOBAL.HTTP_OK) {
        this.totalNovedadesCliente = data.lista[0];
      } else {
        this.totalNovedadesCliente = 0;
      }
    });
  }

  getCountNovedadesAdministrador(){
    return this.countNovedadesAdministrador().subscribe((data : GenericResponse) => {
      if (data.codigo === GLOBAL.HTTP_OK) {
        this.totalNovedadesAdministrador = data.lista[0];
      } else {
        this.totalNovedadesAdministrador = 0;
      }
    });
  }

  private countNovedadesByTerc(tercero:number){
    return this.httpClient.get(this.urlNovedad+'/countNovedadesByTerc/'+tercero);
  }

  private countNovedadesAdministrador(){
    return this.httpClient.get(this.urlNovedad+'/countNovedadesAdministrador/');
  }

}
